export default {
  methods: {
    isGeneralMaterial: (name) => {
      if (
        name === 'General'
        || name === 'VŠEOBECNÉ'
        || name === 'GENERAL'
        || name === 'Генеральная'
        || name === 'Yleinen'
        || name === 'ALGEMENE'
        || name === 'ЗАГАЛЬНІ УМОВИ'
        || name === 'GENEREL'
        || name === 'GÉNÉRAL'
        || name === 'ÁLTALÁNOS'
        || name === 'Generale'
        || name === 'OGÓLNE'
        || name === '通用'
      ) {
        return true;
      }
      return false;
    },
  },
};
